import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import ProfileCard from './components/MainContent';
import Footer from './components/Footer';
import Projects from './pages/Projects'; // Убедитесь, что эти компоненты существуют
import Contacts from './pages/Contacts';
import Resume from './pages/Resume'; // Убедитесь, что эти компоненты существуют
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( <
    React.StrictMode >

    <
    Router >
    <
    Navigation / >
    <
    Routes >
    <
    Route path = '/'
    element = { < ProfileCard / > }
    /> <
    Route path = '/Projects'
    element = { < Projects / > }
    /> <
    Route path = '/CV'
    element = { < Resume / > }
    /> <
    Route path = '/Contacts'
    element = { < Contacts / > }
    /> <
    /Routes> <
    Footer / >
    <
    /Router> <
    /React.StrictMode>
)